import { TextField, MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

const PROVIDER_OPTIONS = [
	{ label: 'All Providers', value: 'all' },
	{ label: 'Microsoft', value: 'microsoft' },
	{ label: 'Google', value: 'google' },
];

const ProviderDropdown = ({ value, onChange }) => {
	// Convert empty string from URL to 'all' for UI display
	const displayValue = value === '' ? 'all' : value;

	const handleChange = (e) => {
		// Convert 'all' back to empty string for backend
		const newValue = e.target.value === 'all' ? '' : e.target.value;
		onChange({ target: { value: newValue } });
	};

	return (
		<TextField
			data-testid='provider-dropdown'
			select
			value={displayValue}
			onChange={handleChange}
			size='small'
			SelectProps={{
				renderValue: (selectedValue) => {
					const option = PROVIDER_OPTIONS.find(
						(opt) => opt.value === selectedValue
					);
					return option?.label || 'All Providers';
				},
			}}
			sx={{
				width: '150px',
			}}
		>
			{PROVIDER_OPTIONS.map((option) => (
				<MenuItem key={option.value} value={option.value}>
					{option.label}
				</MenuItem>
			))}
		</TextField>
	);
};

ProviderDropdown.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default ProviderDropdown;
